import { action, computed, observable, ObservableSet } from 'mobx'
import isEqual from 'lodash/isEqual'
import { computedFn } from 'mobx-utils'

export class TreeNavStore {
  @observable.struct treeRef: any = {}
  @observable selectedTree: string[] = []
  @observable selectedTreeSet = new ObservableSet()

  @action
  setTreeRef = treeRef => {
    if (treeRef?.nodes && !isEqual(treeRef.nodes, this.treeRef?.nodes)) {
      this.treeRef = treeRef
    }
  }

  @action
  setSelectedTree = (selectedTree: string[]) => {
    this.selectedTree = selectedTree
    this.selectedTreeSet.replace(new Set(selectedTree))
  }

  @computed.struct get scrollIndex() {
    return this.treeRef?.nodes?.find(treeNode =>
      this.selectedTree?.length ? this.presentInTree(treeNode, this.selectedTree) : false
    )?.index
  }

  private presentInTree = computedFn((treeNode, tree) => {
    return tree?.[tree?.length - 1] === treeNode?.node?.name
      ? tree.length === 1
        ? true
        : this.presentInTree(treeNode?.parentInfo, tree?.slice(0, tree.length - 1))
      : false
  })

  getLeafNode = (nodeList, id) => {
    let leafNodeId = id
    if (nodeList[id]?.children?.length) {
      leafNodeId = nodeList[id].children?.[0]
      return this.getLeafNode(nodeList, leafNodeId)
    }
    return leafNodeId
  }
}
